import { SimExternalStatus } from './sim.js';
export const CommunicationStatus = {
    Ok: 'ok',
    Booked: 'booked',
    Paused: 'paused',
    Terminated: 'terminated',
    NoSim: 'noSim',
};
export const communicationStatus = (device, sim) => {
    if (device.simId) {
        if (!sim) {
            return undefined;
        }
        switch (sim.status) {
            case SimExternalStatus.SoracomActive:
            case SimExternalStatus.SoracomStandby:
            case SimExternalStatus.SoracomReady:
            case SimExternalStatus.OnceActive:
                return CommunicationStatus.Ok;
            case SimExternalStatus.SoracomInactive:
            case SimExternalStatus.SoracomSuspended:
            case SimExternalStatus.OnceInactive:
                return CommunicationStatus.Paused;
            case SimExternalStatus.SoracomTerminated:
                return CommunicationStatus.Terminated;
        }
    }
    return CommunicationStatus.NoSim;
};
//# sourceMappingURL=communicationStatus.js.map